<div class="modal-header">
  <h4 class="modal-title"><em class="fas fa-save"></em> About</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <h1 class="text-center mb-5">Powered by
    <a href="https://senx.io/" target="_blank"><img src="/assets/img/senx.png" alt="SenX logo"
                                                    style="max-height: 50px; vertical-align: center"></a>
  </h1>
  <p>TrueSea is a turnkey solution for AIS data pipelines, handling the ingestion of AIS feeds and files. It makes that
    data available through powerful APIs and to batch processing tools such as Spark to enable you to perform large
    scale analytics to power your applications.</p>
  <p>TrueSea is compatible with major AIS data providers and can be easily adapted to emerging ones. The solution can
    also mix AIS data with weather, aeronautical, or road traffic data for a global approach.
  <p>
  <p class="text-center mb-5">
    <a href="https://blog.senx.io/ais-data-made-easy/" class="btn btn-primary" target="_blank">Read more about AIS
      data</a>
  </p>
  <p>If you are interested in having a conversation about AIS data and how we can help you get the most out of your
    investment, send us an <a href="mailto:contact@senx.io" target="_blank">email</a>, we will reach back to you rapidly
    to schedule a video call.
  <p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="activeModal.dismiss()">Close</button>
</div>
